import { useEffect, useState } from "react";
import { api, imgUrl } from "@/lib/api";
import { useLang } from "@/context/LangContext";

export default function Gallery() {
  const { t, pick } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="gallery-page" className="pt-24 md:pt-28 pb-20 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs uppercase tracking-[0.3em] text-terracotta mb-4">{t.home.gallery_overline}</p>
        <h1 className="font-serif-display text-4xl md:text-6xl tracking-tight font-light text-charcoal leading-[1.05]">
          {t.gallery_page.title}
        </h1>
        <p className="mt-5 max-w-xl text-charcoal-400">{t.gallery_page.sub}</p>

        <div className="mt-10 md:mt-12 columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-6">
          {items.map((g, i) => (
            <figure key={g.id} className="mb-4 md:mb-6 break-inside-avoid overflow-hidden group" data-testid={`gallery-item-${i}`}>
              <img
                src={imgUrl(g.image_url)}
                alt={pick(g.caption_en, g.caption_fr) || "Oman"}
                className="w-full h-auto object-cover hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
              {(g.caption_en || g.caption_fr) && (
                <figcaption className="mt-2 text-xs text-charcoal-400 italic">{pick(g.caption_en, g.caption_fr)}</figcaption>
              )}
            </figure>
          ))}
        </div>
      </div>
    </div>
  );
}
